<mat-icon class="order-tile-status-icon" fontSet="material-icons-round">{{ icon }}</mat-icon>
<div class="order-tile-status-content">
  <div class="order-tile-status-text ods-typography-microcopy-regular">{{ estimationText | translate }}</div>
  <div class="ods-typography-microcopy-bold">{{ estimationTime }}</div>
</div>
